import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-75e7e5e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "container outcome-content-container" }
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 0,
  class: "stepper"
}

import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import Stepper from "../../components/team-outcomes/progress-stepper.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'personal-outcomes',
  setup(__props) {

const step = ref<number>(-1);

const displayStepper = ref(true);

const route = useRoute();

const backButtonLink = computed<string>(() => {
  const routeName = route?.name;
  switch (routeName) {
    case "selectPersonalPathway":
      return "/my/outcomes/select";
    case "personalPathwaySummary":
      return `/my/outcomes/outcome/${route.params.outcomeUid}/select`;
    case "selectPersonalOutcome":
    default:
      return "/home?view=MyDashboard";
  }
});

const backButtonText = computed<string>(() => {
  return route?.name === "selectPersonalOutcome" ? "My Dashboard" : "Back";
});

const computedStep = computed<number>(() => {
  return step.value;
});

const updateStepper = (routeName: string): void => {
  switch (routeName) {
    case "selectPersonalOutcome":
      step.value = -1;
      break;
    case "selectPersonalPathway":
      step.value = 0;
      break;
    case "personalPathwaySummary":
      step.value = 1;
      break;
    default:
      step.value = -1;
      break;
  }
};

const hideStepper = (): void => {
  displayStepper.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        class: "back-button btn btn-default-back",
        href: backButtonLink.value,
        "data-test": "pg-back-button"
      }, _toDisplayString(backButtonText.value), 9, _hoisted_3),
      _createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view, {
            onUpdateStepper: updateStepper,
            onHideStepper: hideStepper
          })
        ]),
        _: 1
      }),
      (displayStepper.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (step.value !== undefined)
              ? (_openBlock(), _createBlock(Stepper, {
                  key: 0,
                  "completed-step": computedStep.value,
                  "steps-count": 3,
                  "show-tooltip": false
                }, null, 8, ["completed-step"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})